import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { redirectToLogin } from '../../../core/utils/login-redirect.util';
import { markRemoatSignIn } from '../../../core/utils/remoat-return.util';

/**
 * `/remoat/sign-in`: where REMOAT's "Sign in with MedicAI" button lands. A signed-in user is handed straight on to
 * REMOAT with a one-use token; anyone else is asked to sign in here first, and the login comes back here.
 */
@Component({
  selector: 'app-remoat-sign-in',
  templateUrl: './remoat-sign-in.component.html',
  styleUrls: ['./remoat-sign-in.component.scss']
})
export class RemoatSignInComponent implements OnInit {
  message: string | null = null;
  signInFirst = false;

  constructor(private http: HttpClient, private userService: UserService) { }

  ngOnInit(): void {
    if (!this.userService.validateToken()) {
      this.ask('Sign in to MedicAI first. You will come straight back to REMOAT.');
      return;
    }
    this.http.post<{ url: string }>('api/remoat/handoff', {}).subscribe({
      next: ({ url }) => window.location.replace(url),
      error: (error) => {
        const code = error?.error?.error;
        if (code === 'SIGN_IN_AGAIN' || error?.status === 401) {
          this.ask('Please sign in to MedicAI again. You will come straight back to REMOAT.');
        } else if (error?.status === 404) {
          this.message = 'REMOAT sign-in is not switched on here.';
        } else {
          this.message = 'This MedicAI account cannot sign in to REMOAT.';
        }
      }
    });
  }

  signIn(): void {
    markRemoatSignIn();
    redirectToLogin();
  }

  private ask(message: string): void {
    this.message = message;
    this.signInFirst = true;
  }
}
